import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/Images/Rectangle(4).svg'


const _hoisted_1 = { class: "bg-black fixed flex justify-center bottom-0 left-0 items-center bg-opacity-10 w-full h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col w-auto gap-y-3 bg-white shadow-typeBox px-4 py-6 rounded-md"
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-8",
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.displayModal || $props.modal1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeModal && $options.closeModal(...args)))
            }, _hoisted_5)
          ]),
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, $props.displayModal || $props.modal1]
  ])
}